module.exports = __webpack_public_path__ + "static/media/computer-run.9a356f77.svg";